import { createConfig, http } from 'wagmi';
import { mainnet, sepolia } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

const alchemyApiKey = import.meta.env.VITE_ALCHEMY_API_KEY;

// Create transport with fallbacks
const mainnetTransport = alchemyApiKey 
  ? http(`https://eth-mainnet.g.alchemy.com/v2/${alchemyApiKey}`)
  : http(); // Fallback to public RPC

export const config = createConfig({
  chains: [mainnet],
  transports: {
    [mainnet.id]: mainnetTransport,
  },
  connectors: [
    injected(),
  ],
});